var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 6.66667V13.3333H17.6V6.66667C17.6 6.66667 15.3756 5.73333 12 5.73333C8.6244 5.73333 6.4 6.66667 6.4 6.66667ZM14.8 16C14.8 16.736 15.4272 17.3333 16.2 17.3333C16.9728 17.3333 17.6 16.736 17.6 16C17.6 15.264 16.9728 14.6667 16.2 14.6667C15.4272 14.6667 14.8 15.264 14.8 16ZM6.4 16C6.4 16.736 7.0272 17.3333 7.8 17.3333C8.5728 17.3333 9.2 16.736 9.2 16C9.2 15.264 8.5728 14.6667 7.8 14.6667C7.0272 14.6667 6.4 15.264 6.4 16ZM12 4C16.2 4 19 5.33333 19 5.33333V6.50002L20.2378 7.32521C20.398 7.43202 20.4826 7.62133 20.4554 7.81194L20.037 10.7407C20.0138 10.9031 19.9124 11.0438 19.7656 11.1172L19 11.5V18.6667C19 19.403 18.3732 20 17.6 20H16.2L15.5 18.6667H8.5L7.8 20H6.4C5.6268 20 5 19.403 5 18.6667V5.33333C5 5.33333 7.8 4 12 4ZM3.76216 7.32521L4.99997 6.5V11.5L4.23429 11.1172C4.08754 11.0438 3.98612 10.9031 3.96292 10.7407L3.54453 7.81194C3.5173 7.62133 3.60195 7.43202 3.76216 7.32521Z",
    fill: "#1A73F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.fffbeff9785f9e255b03887c74f68542.svg";
export { ForwardRef as ReactComponent };